module.exports = __webpack_public_path__ + "img/7.928117e4.png";